var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('terms-dialog', _vm._b({
    attrs: {
      "code": _vm.code
    },
    on: {
      "isLoaded": _vm.setTermsList,
      "input": function input(value) {
        return _vm.$emit('input', value);
      },
      "isValid": function isValid(_isValid) {
        return _vm.$emit('isValid', _isValid);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            isValid = _ref.isValid;
        return [_c('div', _vm._g({
          staticClass: "cursor-pointer"
        }, on), [_c('v-card', {
          attrs: {
            "outlined": "",
            "tile": ""
          }
        }, [_c('v-layout', [_c('div', {
          staticClass: "px-16 py-8 px-md-20"
        }, [_vm._l(_vm.termsList, function (terms) {
          return [_c('v-checkbox', {
            key: terms._id,
            staticClass: "my-8 my-md-12",
            attrs: {
              "value": _vm.selected.includes(terms._id),
              "hide-details": "",
              "color": "primary",
              "readonly": ""
            },
            scopedSlots: _vm._u([{
              key: "label",
              fn: function fn() {
                return [_vm._v(" " + _vm._s(terms.subject) + " "), _c('span', {
                  staticClass: "pl-4",
                  class: [terms.necessary ? 'red--text' : 'grey--text text--lighten-1']
                }, [_vm._v("(" + _vm._s(terms.necessary ? "필수" : "선택") + ")")])];
              },
              proxy: true
            }], null, true)
          })];
        })], 2)])], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  }, 'terms-dialog', {
    params: _vm.params
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }